/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:30
 * @LastEditors: yy
 * @LastEditTime: 2019-09-29 10:07:26
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Deepsea.css';
// @ts-ignore
import ReactEcharts from 'echarts-for-react'

import DeepSeaSelect from '../DeepSeaSelect'
import moment from 'moment'

class Deepsea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasNewsState: this.props.hasNewsState
    };

    this.getOption = this.getOption.bind(this);
    this.onChartClick = this.onChartClick.bind(this);
  }


  getOption = () => {

    let chartsJson = this.props.json;
    const {seaQuery, seaState} = this.props

    if (!chartsJson.hundred_homes_dataList) {
      chartsJson.hundred_homes_dataList = []
    }
    if (!chartsJson.news_dataList) {
      chartsJson.news_dataList = []
    }


    let [kolWB, kolWX, kolZH, kolTT, kolNews, kolHundredHomes] = [[], [], [], [], [], []]

    const pageNum = chartsJson.pageNumList['all']

    function randomData(i, range) {
      // now = new Date(+now - oneDay);
      now = new Date(+now);
      let rangeSum = range * 4000 - 10000
      let value = Math.random() * ((rangeSum + 4000) - rangeSum) + rangeSum;
      var hour = Math.round(Math.random() * 24)

      return [
        [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/') + ' ' + hour + ':00',
        Math.round(value),
        i
      ]
    }

    let year = this.props.time.substring(0, 4)
    let month = (this.props.time.substring(5, 7) - 1)
    let day = this.props.time.substring(8, 10)
    let [dataWB, dataWX, dataZH, dataTT, dataNews, dataHundredHomes] = [[], [], [], [], [], []];
    var now = +new Date(year, month, day);
    var oneDay = 24 * 3600 * 1000;

    now = new Date(now + oneDay)

    
    let dataLength = 7;

    if (seaState) {
      // 当前时间 初始化
      now = new Date(+new Date())
      console.log('--init',moment(now).format('YYYY.MM.DD'));

      // 开始时间
      const begin = moment(seaQuery.seaStartTime);
      // 结束时间
      const end = moment(seaQuery.seaEndTime);
      // 当前时间
      const nowT = moment(new Date())

      // 结束时间和开始时间间隔
      dataLength = end.diff(begin, 'day') + 1;

      // 当前时间和结束时间间隔 （当前时间 - 一天时间*时间间隔 + 一天时间） = 结束时间
      now = new Date(now - oneDay * nowT.diff(end, 'day') + oneDay)
      console.log('--end',moment(now).format('YYYY.MM.DD'));

    }
    console.log('--数据长度：', dataLength);
    
    for (var q = 0; q < dataLength; q++) {
      console.log('==end',moment(now).format('YYYY.MM.DD'));
      
      now = new Date(now - oneDay)
      console.log('++end',moment(now).format('YYYY.MM.DD'));

      for (var i = 1; i < 7; i++) {
        // wb
        for (var j = 0; j < chartsJson.wb_dataList[q][i].better; j++) {
          dataWB.unshift(randomData(i, 4))
        }
        for (var j = 0; j < chartsJson.wb_dataList[q][i].good; j++) {
          dataWB.unshift(randomData(i, 3))
        }
        for (var j = 0; j < chartsJson.wb_dataList[q][i].ne; j++) {
          dataWB.unshift(randomData(i, 2))
        }
        for (var j = 0; j < chartsJson.wb_dataList[q][i].bad; j++) {
          dataWB.unshift(randomData(i, 1))
          // badSum++
        }
        for (var j = 0; j < chartsJson.wb_dataList[q][i].worse; j++) {
          dataWB.unshift(randomData(i, 0))
          // worseSum++
        }
        // // wx
        for (var j = 0; j < chartsJson.wx_dataList[q][i].better; j++) {
          dataWX.unshift(randomData(i, 4));
          // betterSum++
        }
        for (var j = 0; j < chartsJson.wx_dataList[q][i].good; j++) {
          dataWX.unshift(randomData(i, 3))
          // goodSum++
        }
        for (var j = 0; j < chartsJson.wx_dataList[q][i].ne; j++) {
          dataWX.unshift(randomData(i, 2))
          // neSum++
        }
        for (var j = 0; j < chartsJson.wx_dataList[q][i].bad; j++) {
          dataWX.unshift(randomData(i, 1))
          // badSum++
        }
        for (var j = 0; j < chartsJson.wx_dataList[q][i].worse; j++) {
          dataWX.unshift(randomData(i, 0))
          // worseSum++
        }
        // zh
        for (var j = 0; j < chartsJson.zh_dataList[q][i].better; j++) {
          dataZH.unshift(randomData(i, 4));
          // betterSum++
        }
        for (var j = 0; j < chartsJson.zh_dataList[q][i].good; j++) {
          dataZH.unshift(randomData(i, 3))
          // goodSum++
        }
        for (var j = 0; j < chartsJson.zh_dataList[q][i].ne; j++) {
          dataZH.unshift(randomData(i, 2))
          // neSum++
        }
        for (var j = 0; j < chartsJson.zh_dataList[q][i].bad; j++) {
          dataZH.unshift(randomData(i, 1))
          // badSum++
        }
        for (var j = 0; j < chartsJson.zh_dataList[q][i].worse; j++) {
          dataZH.unshift(randomData(i, 0))
          // worseSum++
        }
        // // tt
        for (var j = 0; j < chartsJson.tt_dataList[q][i].better; j++) {
          dataTT.unshift(randomData(i, 4));
          // betterSum++
        }
        for (var j = 0; j < chartsJson.tt_dataList[q][i].good; j++) {
          dataTT.unshift(randomData(i, 3))
          // goodSum++
        }
        for (var j = 0; j < chartsJson.tt_dataList[q][i].ne; j++) {
          dataTT.unshift(randomData(i, 2))
          // neSum++
        }
        for (var j = 0; j < chartsJson.tt_dataList[q][i].bad; j++) {
          dataTT.unshift(randomData(i, 1))
          // badSum++
        }
        for (var j = 0; j < chartsJson.tt_dataList[q][i].worse; j++) {
          dataTT.unshift(randomData(i, 0))
          // worseSum++
        }
        // news
        if (chartsJson.news_dataList.length > 0) {
          for (var j = 0; j < chartsJson.news_dataList[q][i].better; j++) {
            dataNews.unshift(randomData(i, 4));
            // betterSum++
          }
          for (var j = 0; j < chartsJson.news_dataList[q][i].good; j++) {
            dataNews.unshift(randomData(i, 3))
            // goodSum++
          }
          for (var j = 0; j < chartsJson.news_dataList[q][i].ne; j++) {
            dataNews.unshift(randomData(i, 2))
            // neSum++
          }
          for (var j = 0; j < chartsJson.news_dataList[q][i].bad; j++) {
            dataNews.unshift(randomData(i, 1))
            // badSum++
          }
          for (var j = 0; j < chartsJson.news_dataList[q][i].worse; j++) {
            dataNews.unshift(randomData(i, 0))
            // worseSum++
          }
        }
        // dataHundredHomes
        if (chartsJson.hundred_homes_dataList.length > 0) {
          for (var j = 0; j < chartsJson.hundred_homes_dataList[q][i].better; j++) {
            dataHundredHomes.unshift(randomData(i, 4));
            // betterSum++
          }
          for (var j = 0; j < chartsJson.hundred_homes_dataList[q][i].good; j++) {
            dataHundredHomes.unshift(randomData(i, 3))
            // goodSum++
          }
          for (var j = 0; j < chartsJson.hundred_homes_dataList[q][i].ne; j++) {
            dataHundredHomes.unshift(randomData(i, 2))
            // neSum++
          }
          for (var j = 0; j < chartsJson.hundred_homes_dataList[q][i].bad; j++) {
            dataHundredHomes.unshift(randomData(i, 1))
            // badSum++
          }
          for (var j = 0; j < chartsJson.hundred_homes_dataList[q][i].worse; j++) {
            dataHundredHomes.unshift(randomData(i, 0))
            // worseSum++
          }

        }
      }

    }


    var pastWeek = new Date(year, month, day - 7)

    dataWB.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])
    dataWX.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])
    dataZH.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])
    dataTT.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])
    dataNews.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])
    dataHundredHomes.unshift([[now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'), null])


    dataWB.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])
    dataWX.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])
    dataZH.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])
    dataTT.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])
    dataNews.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])
    dataHundredHomes.push([[now.getFullYear(), now.getMonth() + 1, now.getDate() + dataLength].join('/'), null])


    var yList = [[], [`反感 ${pageNum[4]}篇`], [], [`差评 ${pageNum[3]}篇`], [], [`中立 ${pageNum[2]}篇`], [], [`好感 ${pageNum[1]}篇`], [], [`推荐 ${pageNum[0]}篇`]]

    let option = {
      baseOption: {
        // 微博、微信、知乎、头条
        color: ['#e88245', '#63c06b', '#4cb8ed', '#f44336', '#c71969', '#ffeb3b'],
        toolbox: {
          right: 20,
          show: true,
          feature: {
            mark: { show: true },
            //          dataView : {show: true, readOnly: false},
            magicType: {
              show: true,
              type: ['pie', 'funnel']
            },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        title: {
          text: `口碑舆情图 -${this.props.items.name}`,
          subtext: '数据来源：数字品牌榜',
          x: '20px',
          textStyle: {
            fontSize: 18,
            fontWeight: 'bolder',
            color: '#333'
          },
        },
        grid: {
          show: true,
          x: 120,
          y: 80,
          x2: 110,
          y2: 60,
          backgroundColor: 'rgba(0,0,255,0)',
          borderWidth: 1,
          borderColor: '#ccc'
        },
        xAxis: {
          type: 'time',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },

          axisLabel: {
            interval: 0
          },
          // splitNumber: 10
        },
        yAxis: {
          type: 'value',
          name: '',
          nameLocation: 'start',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 14
          },
          min: -10000,
          max: 10000,
          splitNumber: 10,
          scale: true,
          splitArea: {
            show: true,
            areaStyle: {
              color: ['#eceff2', '#eceff2', '#f2f4f5', '#f2f4f5', '#fafbfb', '#fafbfb', '#f2f4f5', '#f2f4f5', '#eceff2', '#eceff2']
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#777'
            }
          },
          axisTick: {
            show: false,
            interval: 200,
            lineStyle: {
              color: '#777'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              align: '',
              fontWeight: 400,
              fontSize: 16,
            },
            formatter: function (param, index) {
              return yList[index]
            }
          }
        },
        legend: {
          data: ['微博', '微信', '知乎', '今日头条', '新闻', '百家号'],
          orient: 'vertical',
          right: 10,
          bottom: 10
        },
        graphic: [{
          type: 'text',
          z: 102,
          top: '25',
          left: '450',
          style: {
            text: [
              '传播度'
            ].join('\n'),
            font: '16px "STHeiti", sans-serif'
          }

        }, {
          type: 'circle',
          z: 100,
          left: '530',
          top: '32',
          shape: {
            r: 2
          },
          style: {
            fill: '#ccc',
            // stroke: '#ccc',
            lineWidth: 2,

            shadowColor: '#ffd70d'
          }
        },
        {
          type: 'circle',
          z: 100,
          left: '580',
          top: '20',
          shape: {
            r: 12
          },
          style: {
            fill: '#ccc',
            // stroke: '#ccc',
            lineWidth: 2,
            shadowColor: '#ffd70d'
          }
        }],
        series: [
          {
            name: ['微博'],
            type: 'scatter',
            data: dataWB.map(function (node) {
              
              let color, symbolSize, symbol;

              if (node[2] == 6) {
                color = '#e5a075',
                  symbolSize = 4
              } else if (node[2] == 5) {
                color = '#e69b6b',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#e69561',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#e78e57',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#e7884f',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#e88245',
                  symbolSize = 16
              }

              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                return
              }
            },
          },
          {
            name: ['微信'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: dataWX.map(function (node) {

              let color,
                symbolSize,
                symbol

              if (node[2] == 6) {
                color = '#95ca8f',
                  symbolSize = 4
              } else if (node[2] == 5) {
                color = '#8cc688',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#82c281',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#78be7a',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#6fba73',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#65b66b',
                  symbolSize = 16
              }

              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                return
              }
            },
          },
          {
            name: ['知乎'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: dataZH.map(function (node) {
              let color,
                symbolSize,
                symbol


              if (node[2] == 6) {
                color = '#72bde1',
                  symbolSize = 4

              } else if (node[2] == 5) {
                color = '#6ab8dc',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#62b2d5',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#53acd0',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#44a8cb',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#35a3c5',
                  symbolSize = 16
              }

              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                // symbol:'rect',
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                // console.log
                return
              }
            },
          }, {
            name: ['今日头条'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: dataTT.map(function (node) {
              let color,
                symbolSize,
                symbol


              if (node[2] == 6) {
                color = '#e3999a',
                  symbolSize = 4

              } else if (node[2] == 5) {
                color = '#e18d8c',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#de827f',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#dc7673',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#d96c68',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#d7605c',
                  symbolSize = 16
              }

              color = '#f44336';
              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                // symbol:'rect',
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                // console.log
                return
              }
            },
          },
          
          {
            name: ['新闻'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: dataNews.map(function (node) {
              let color,
                symbolSize,
                symbol


              if (node[2] == 6) {
                color = '#8419c7',
                  symbolSize = 4

              } else if (node[2] == 5) {
                color = '#8419c7',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#8419c7',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#8419c7',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#8419c7',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#8419c7',
                  symbolSize = 16
              }

              color = '#c71969';
              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                // symbol:'rect',
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                // console.log
                return
              }
            },
          },
          
          {
            name: ['百家号'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: dataHundredHomes.map(function (node) {
              let color,
                symbolSize,
                symbol

              if (node[2] == 6) {
                color = '#19c7b9',
                  symbolSize = 4

              } else if (node[2] == 5) {
                color = '#e18d8c',
                  symbolSize = 8
              } else if (node[2] == 4) {
                color = '#de827f',
                  symbolSize = 10
              } else if (node[2] == 3) {
                color = '#dc7673',
                  symbolSize = 12
              } else if (node[2] == 2) {
                color = '#d96c68',
                  symbolSize = 14
              } else if (node[2] == 1) {
                color = '#d7605c',
                  symbolSize = 16
              }

              color = '#ffeb3b'
              return {
                value: [node[0], node[1]],
                symbolSize: symbolSize,
                // symbol:'rect',
                itemStyle: {
                  normal: {
                    color: color
                  }
                }
              }
            }),
            label: {
              normal: {
                // formatter: '{a}'
              },
              emphasis: {
                show: false,
                // formatter: '{a}\n{c}',
                position: 'top'
              }
            },

            tooltip: {
              formatter: function (params) {
                // console.log
                return
              }
            },
          },

          
          {
            name: ['微博'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolWB.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },

            },

            symbolSize: function (data) {

              return 22;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },

            },
          }, {
            name: ['微信'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolWX.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },

            },

            symbolSize: function (data) {

              return 22;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },

            },
          }, {
            name: ['知乎'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolZH.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },

            },

            symbolSize: function (data) {

              return 22;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },

            },
          }, {
            name: ['今日头条'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolTT.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },

            },

            symbolSize: function (data) {

              return 22;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },

            },
          }
          
          , {
            name: ['新闻'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolNews.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },

            },

            symbolSize: function (data) {

              return 4;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },

            },
          }, {
            name: ['百家号'],
            type: 'scatter',
            // itemStyle: itemStyle,
            data: kolHundredHomes.map(function (node) {
              return { value: [node[0], node[1], node[2], node[3]] }
            }),
            zlevel: 200,
            label: {
              normal: {
                formatter: '{a}'
              },
              emphasis: {
                // show: false,
                formatter: function (param) {
                  return param.data[2]

                },
                position: 'top'
              },
            },
            symbolSize: function (data) {
              return 22;
            },
            // symbol:'rect',
            tooltip: {
              formatter: function (params) {
                return params.data.value[2]
              },
            }
          }
        
        ]
      }
    }

    return option

  }

  onChartClick = (params) => {
    if (params.value[3]) {
      window.open(params.value[3])
    }
  }
  legendChange (params) {
    //  点击legend变化左边的情感篇数
    console.log(params)
    //   for( i in params){
    //     //   console.log(params.selected[i][key])
    //     console.log(params[i])
    //   }
    console.log(params.selected)
  }

  render() {
    let onEvents = {
      'click': this.onChartClick,
      'legendselectchanged': this.legendChange
    }

    console.log(this.state.hasNewsState);
    const hasNewsState = this.state.hasNewsState;

    return (
      <div className={s.deepSeaTip}>
        <i>i</i>
        <div className={s.pageNumPosi}>
          <DeepSeaSelect json={this.props.json.pageNumList} hasNewsState={hasNewsState} />
        </div>
        <ReactEcharts
          option={this.getOption()}
          style={{
            height: '550px',
            width: '100%',
            borderRadius: '4px'
          }}
          onEvents={onEvents}
          className={s.charts}
          notMerge={true}
          lazyUpdate={false}
          theme={"theme_name"}
          onChartReady={this.onChartReadyCallback} />
      </div>

    )

  }
}

export default withStyles(s)(Deepsea);



// WEBPACK FOOTER //
// src/components/Deepsea/Deepsea.js